import {
    infoColor,
    infoBoxShadow,
    whiteColor,
    successColor,
    dangerColor,
} from '../global';

const adminListOrganizerStyle = (theme) => ({
    maxHeight: {
        '& td,th': {
            padding: '0px 16px',
        },
    },
    organizerButton: {
        textAlign: 'center',
        position: 'relative',
        height: '43px',
    },
    organizerButtonRegister: {
        position: 'absolute',
        right: '0',
    },
    eventName: {
        paddingBottom: '15px',
        borderBottom: '1px solid #0000001f',
    },
    eventInfo: {
        display: 'flex',
        alignItems: 'center',
        margin: '2vh 0',
        [theme.breakpoints.down('xs')]: {
            margin: '2vh 0',
        },
    },
    booth: {
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        paddingLeft: '20px',
        paddingRight: '20px',
        width: '100%',
        height: '100%',
    },
    marginAuto: {
        margin: 'Auto',
    },
    image: {
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        margin: 15,
        height: 200,
    },
    wrapper: {
        backgroundColor: whiteColor,
    },
    marginBt2vh: {
        marginBottom: '2vh',
    },
    margin2vh: {
        margin: '2vh 0',
        [theme.breakpoints.down('xs')]: {
            margin: '2vh 0',
        },
    },
    paddingLefe3vW: {
        paddingLeft: '3vW',
    },
    paddingTop5vh: {
        paddingTop: '5vh',
    },
    textCenter: {
        textAlign: 'center',
    },
    textLeft: {
        textAlign: 'left',
    },
    displayTextInline: {
        display: 'inline',
    },
    formInputInformation: {
        maxWidth: '1000px',
        border: '1px solid',
        ...infoBoxShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        zIndex: 20,
        background: whiteColor,
        borderColor: infoColor,
        borderRadius: '1%',
        paddingTop: '5vh',
        paddingBottom: '5vh',
    },
    background: {
        minHeight: '500px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: whiteColor,
        display: 'flex',
        borderRadius: '8px',
        // [theme.breakpoints.up('md')]: {
        //     backgroundImage: 'url("/resources/mask_group.png")',
        //     backgroundPosition: 'left',
        //     backgroundSize: 'auto',
        //     backgroundRepeat: 'no-repeat',
        // },
    },
    spacing: {
        padding: '15px 0',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '4px 0px',
            '& .MuiGrid-item': {
                padding: '0px 0px 7px 0px',
            },
        },
    },
    padding15: {
        padding: '15px 15px 0px 0px',
    },
    note: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    tooltipStyle: {
        marginTop: -10,
        padding: 0,
    },
    number: {
        color: whiteColor,
        background: 'orange',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        minWidth: '25px',
        textAlign: 'center',
        fontWeight: 700,
        padding: 2,
    },
    noteContent: {
        paddingLeft: theme.spacing(1.25),
        paddingRight: 0,
    },
    maxHeightTable: {
        maxHeight: 220,
    },
    divider: {
        marginTop: '15px',
        [theme.breakpoints.up('md')]: {
            marginLeft: '15px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '-15px',
            marginRight: '-15px',
        },
    },
    margin28: {
        marginLeft: '28px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '14px',
        },
    },
    paddingLeft15: {
        paddingLeft: '15px',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '0px',
        },
    },
    label: {
        fontSize: '15px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '80%',
        },
    },
    paddingTop15: {
        paddingTop: '15px',
    },
    paddingTop10: {
        paddingTop: '10px',
    },
    timeAddButton: {
        color: successColor,
    },
    roomRemoveButton: {
        color: dangerColor,
    },
    numberInput: {
        width: '70px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
    name: {
        '& input': {
            padding: '6px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    messageError: {
        color: dangerColor,
        marginLeft: '30px',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '250px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '150px !important',
            margin: '10px  !important',
        },
    },
    time_ranger: {
        '& div': {
            '& div': {
                '& div': {
                    paddingRight: '3px',
                    '& div': {
                        paddingRight: '0px',
                    },
                },
            },
        },
    },
    checkBoxDisable: {
        pointerEvents: 'none',
        '& span': {
            fontSize: '14px',
        },
    },
});

export default adminListOrganizerStyle;
